<template>
  <div class="admin">
    <div class="title">
      <img class="title_img"
           src="../../../assets/images/08/guanli_icon.png"
           alt="">
      管理员
    </div>
    <div class="addBtn">
      <router-link to="administrator/addAdmin">
        <el-button type="warning"
                   size="small"
                   class="add_btn">添加</el-button>
      </router-link>
    </div>
    <div class="main_admin">
      <el-table :data="data.result"
                ref="multipleTable"
                style="width: 100%"
                class="main-data"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40">
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="管理员姓名">
          <template slot-scope="scope">
            <div>{{scope.row.name}}</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="角色名称">
          <template slot-scope="scope">
            <div>{{scope.row.roleName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="归属公司"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.companyName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="归属部门"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.departmentName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="管理员账号"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.phone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="电话"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.telephone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div size="medium"
                 v-if="scope.row.state === 0">正常</div>
            <div size="medium"
                 v-else-if="scope.row.state === 1">停用</div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="165">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>

            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getAdmin, deleteAdmin } from 'apis/index'
export default {
  name: 'operation',
  data () {
    return {
      data: {}
    }
  },
  methods: {
    getData () { // 获取数据
      getAdmin().then(res => {
        if (res.data.code === 200) {
          // console.log(res)
          this.data = res.data.data
        }
      })
    },
    handleUpdateClick (id) { // 修改
      this.$router.push({ path: 'administrator/addAdmin', query: { 'company': id } })
    },
    handleDeleteClick (id) { // 删除
      deleteAdmin({
        id: id,
        state: 2
      }).then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          for (var i = 0; i < this.data.result.length; i++) { // 从当前列别表中删除该数据
            if (this.data.result[i].id === id) {
              this.data.result.splice(i, 1)
            }
          }
        }
      })
    },

    handleCurrentChange (val) { // 分 页
      let pageNum = val
      getAdmin({ pageNum }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.admin
  height 100%
  padding 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    background #fff
    border-bottom 1px solid #cfd5dc
    .title_img
      margin 0 8px 0 14px
  .addBtn
    width 100%
    height 46px
    background #fff
    .add_btn
      padding 7px 26px
      float right
      margin-top 10px
      margin-right 20px
  .main_admin
    width 100%
    height calc(100% - 168px)
    background #ff738f
    .el-table
      th
        background #e7f0f8
        .cell
          height 25px
          line-height 25px
      td
        height 80px
        .cell
          size12()
          .el-button
            padding 6px 14px
            width 28px
            cursor pointer
            height 28px
            margin 0 8px
            &.update
              update01()
            &.unblocked
              unblocked01()
            &.delete
              delete01()
            &.addNew
              addNew01()
      .el-table
        thead
          display none
        td
          .cell
            .subTitlename
              padding-left 95px
      .el-table__expanded-cell
        padding 0
      .el-table td, .el-table th.is-leaf
        border-bottom none
        background #E6F3FE
  .el-pagination
    color #5e656f
    font-weight 100
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
    border 1px solid #cfd5dc
    background #fff
  .pages
    margin-top 15px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
</style>
